import { FC, useState } from "react";
import { CodeControlBaseProps } from "./CodeControlTab";
import { TextInput } from "../../../../components/controls/inputs";
import styles from "../styles/CodeControl.module.scss"
import stylesCustomDiv from "../styles/CustomDiv.module.scss"
import stylesBasic from "../styles/BasicSettings.module.scss"
import GridWrapper from "../../../../components/controls/GridWrapper";
import { CheckBox } from "../../../../components/controls/checkbox";
import { v4 as uuidv4 } from 'uuid';
import { DecimalInput } from "../../../../components/controls/inputs/BaseInput";
import { IOption, Select } from "../../../../components/selects/select";

export interface SettingsOfflineProps extends CodeControlBaseProps {

}

const { fieldsetStyles, legendStyles, checkboxMarginStyles, marginStyles } = {
    fieldsetStyles: styles.codeControl_fieldSet,
    legendStyles: styles.codeControl_legend,
    checkboxMarginStyles: stylesBasic.basicSettingsStyles_checkbox,
    marginStyles: stylesCustomDiv.mr  
};

const offlineVerOptions: IOption[] = [
    { displayName: 'VER_1.1', value: 'VER_1.1' }, 
    { displayName: 'VER_1.2', value: 'VER_1.2' },
    { displayName: 'VER_2.1', value: 'VER_2.1' }
];

export const SettingsOffline: FC<SettingsOfflineProps> = ({ data, onChange }) => {
    const parsedData = data && JSON.parse(data?.jsonData).Value;
    const [offlineOption, setOfflineOption] = useState<IOption>({ 
        displayName: parsedData.OfflineVersion ?? offlineVerOptions[0], 
        value: parsedData.OfflineVersion ?? offlineVerOptions[0]
    });

    return (<>
        <div className="container">
          <section className="content-section">
            <fieldset className={fieldsetStyles}>
                    <legend className={legendStyles}>Настройка авторизации</legend>
                        <GridWrapper cols={3}>
                            <TextInput 
                                value={parsedData.OfflineLogin}
                                onChange={(value) => onChange(value, 'OfflineLogin')}
                                label="Логин" 
                            />
                            <TextInput 
                                label="Пароль" 
                                type="password" 
                                pattern="*"
                                value={parsedData.OfflinePassword}
                                onChange={(value) => onChange(value, 'OfflinePassword')}
                            />
                        <Select
                            defaultOption={offlineVerOptions[0]}
                            value={offlineOption}
                            options={offlineVerOptions}
                            label="Версия"
                            onSelect={(option: IOption) => {
                                setOfflineOption(option);
                                onChange(option.value as string, 'OfflineVersion');
                            }}
                        />
                        </GridWrapper>
                        <GridWrapper cols={2}>
                            <TextInput
                                label="Сервер"
                                value={parsedData.OfflineServer}
                                onChange={(value) => onChange(value, 'OfflineServer')}
                            />
                            <TextInput 
                                label="Порт"
                                value={parsedData.OfflinePort}
                                onChange={(value) => onChange(value, 'OfflinePort')}
                            />
                        </GridWrapper>
                        <GridWrapper cols={2}>
                            <DecimalInput 
                                label="Максимальный таймаут ответа ЧЗ онлайн в миллисекундах"
                                value={parsedData.RequestTimeMax}
                                onChange={(value) => onChange(value, 'RequestTimeMax')}
                            />
                            <TextInput 
                                label="Токен:"
                                value={parsedData.OfflineToken}
                                onChange={(value) => onChange(value, 'OfflineToken')}
                            />
                        </GridWrapper>
            </fieldset>
           </section>

           <section className="content-section">
            <fieldset className={fieldsetStyles}>
                <legend className={legendStyles}></legend>
                    <CheckBox
                        id={uuidv4()}
                        label="Офлайн режим включен"
                        className={checkboxMarginStyles}
                        defaultChecked={parsedData?.OfflineRegimeEnabled === '1' ? true : false}
                        onChanged={(value) => onChange(value ? '1' : '0','OfflineRegimeEnabled')}
                    />
                    <CheckBox
                        id={uuidv4()}
                        label="Разрешить печатать чек, если ЛМ ЧЗ не отвечает"
                        className={checkboxMarginStyles}
                        defaultChecked={parsedData?.AllowChequePrintLMCZNoAnswer === '1' ? true : false}
                        onChanged={(value) => onChange(value ? '1' : '0','AllowChequePrintLMCZNoAnswer')}
                    />
                    <Label text="Решение принимается торговой точкой согласно конструкции ЧЗ 1944. Значение настройки чек-бокса по умолчанию Не разрешено."></Label>
                    <Label text="В случае разрешения - возможна ответственность в соответствии с КоАП 15.12.1 при печати чека - без проверки разрешительного режима"></Label>                        
            </fieldset>              
           </section>
        </div>
    </>)  
}

const Label = ({ text }) => (
    <div className={marginStyles}>{text}</div>
);